/** Any ids to be masked by playwright for visual comparison purposes */
export const MASKED_TEST_IDS = {
  STACK_WIDGET_1: 'stack_widget_1',
  STACK_WIDGET_2: 'stack_widget_2',
  AUTH_TOKEN_VIEWER: 'auth_token_viewer',
  ADMIN_TOS_IP_ADDRESS: 'admin_tos_ip_address',
  ADMIN_LEGAL_ACCEPTANCE_IP_ADDRESS: 'admin_legal_acceptance_ip_address',
  MAGIC_TABLE: 'magic_table',
  IMAGE_SLIDE: 'image_slider',
  SSO_SIGN_UP_PORTAL: 'sso_sign_up_portal',
} as const;

const EXTERNAL_TEST_IDS = {
  APP_INSPECTOR_SPAN_LIST: 'spans-list-page',
};

// e2e contracts for the users & licenses page
export const USER_AND_LICENSES_TEST_IDS = {
  INVITE_USER_BUTTON: 'invite_user_button',
  INVITE_USER_MODAL: 'invite_user_modal',
};

// e2e contracts for the invitation acceptance view
export const ACCEPT_INVITATION_TEST_IDS = {
  // steps
  ACCEPT_INVITATION_FOR_EXISTING_ACCOUNT_STEP: 'accept_invitation_for_existing_account_step',
  ACCEPT_INVITATION_FOR_NEW_ACCOUNT_STEP: 'accept_invitation_for_new_account_step',
  STRICT_SSO_STEP: 'strict_sso_step',
  FINALIZATION_STEP: 'finalization_step',
  // elements
  NEW_ACCOUNT_PASSWORD_FIELD: 'new_account_password_field',
  NEW_ACCOUNT_CONFIRM_BUTTON: 'new_account_confirm_button',
  NEW_ACCOUNT_PASSWORD_TOGGLE: 'new_account_password_toggle',
  EXISTING_ACCOUNT_CONFIRM_BUTTON: 'existing_account_confirm_button',
};

// e2e contracts for the pricing, trial banner and billing subscription views
const PRICING_TEST_IDS = {
  TRIAL_BANNER_PILL: 'trial_banner_pill',
  TRIAL_BANNER_MENU_ITEM: (emulator: string): string => `trial_banner_menu_item_${emulator}`,
  EMULATOR_TOGGLE: 'emulator_toggle',
  EMULATOR_TOGGLE_SEGMENT: (emulator: string): string => `emulator_toggle_segment_${emulator}`,
  PRICING_TRIAL_STRIP: 'pricing_trial_strip',
  PRICING_TRIAL_BUTTON: 'pricing_trial_button',
  BILLING_EMULATOR_GROUP: (emulator: string): string => `billing_emulator_group_${emulator}`,
  BILLING_EMULATOR_PROMPT: (emulator: string): string => `billing_emulator_prompt_${emulator}`,
  FEATURE_UNAVAILABLE_BOX: 'feature_unavailable_box',
  FEATURE_UNAVAILABLE_EMULATOR_PILL: 'feature_unavailable_emulator_pill',
};

const LAMBDA_WEB_TEST_IDS = {
  LAMBDA_WEB_FORM_SUBMIT: 'lambda_web_form_submit',
};

export const TEST_IDS = {
  ...MASKED_TEST_IDS,
  ...EXTERNAL_TEST_IDS,
  ...PRICING_TEST_IDS,
  ...LAMBDA_WEB_TEST_IDS,
  ADMIN_LEGAL_ACCEPTANCE_SOURCE: 'admin_legal_acceptance_source',
  WORKSPACE_SELECTOR: 'workspace_selector',
  REGION_DROPDOWN: 'region_dropdown',
  LICENSES_USED: 'licenses_used',
  IFRAME_EXTENSION: 'iframe_extension',
  DARK_MODE_BUTTON: 'dark_mode_button',
  GETTING_STARTED_PROMPT_STRIP: 'getting_started_prompt_strip',
  GETTING_STARTED_PROMPT_BUTTON: 'getting_started_prompt_button',
  GETTING_STARTED_DOC_TILES: (emulator: string): string => `getting_started_doc_tiles_${emulator}`,
} as const;
